var $ = require('jquery');

var helper = require('../helpers/outsideClick.js');

// Elements
var $article = $('div.article');
var $h2headings = $article.find('> h2');

var $pageNavigation = $('[data-page-navigation]');
var $pageNavigationFixed = $pageNavigation.find('.page-navigation__fixed-container');
var $pageNavigationButton = $pageNavigation.find('.page-navigation__button');
var $pageNavigationItems = $pageNavigation.find('.page-navigation__items');
var $pageNavigationToTop = $pageNavigation.find('.page-navigation__to-top-button');

// Classes
var $baseClass = 'page-navigation';
var expandedClass = $baseClass + '--expanded';
var fixedClass = $baseClass + '--fixed';
var itemButtonClass = $baseClass + '__item-button';
var listItemClass = $baseClass + '__list-item';
var activeListItemClass = $baseClass + '__list-item--active';

// Constants
var SCROLL_SPEED = 1000;
var MOBILE_MENU_HEIGHT = 54;
var MOBILE_BREAKPOINT = 640;
var SCROLL_MARGIN = 10;

$(document).ready(function () {
	if ($article.length === 0 || $pageNavigation.length === 0) return false;
	var pageNavigationHeight = 0;
	var listItemButtonIndex = 0;

	var createPagenavigation = {
		init: function () {
			this.toggleMenu();
			this.createLinksFromHeadings();
			this.addKeyboardNavigation();
			this.addScrollEvents();
			this.addBackToTopLink();
			this.initOutsideClick();
		},
		toggleMenu: function () {
			var self = this;
			$pageNavigationButton.on('click', function () {
				if ($pageNavigation.hasClass(expandedClass)) {
					self.collapseMenu();
				} else {
					$pageNavigation.addClass(expandedClass);
					$pageNavigationButton.attr('aria-expanded', true);
					$pageNavigationItems.attr('aria-hidden', false);
					$pageNavigationItems.find('button').first().focus();
					listItemButtonIndex = 0;
				}
			});
		},
		createLinksFromHeadings: function () {
			var self = this;
			$.each($h2headings, function (i, heading) {
				var $heading = $(heading);
				var headingText = $heading.text();
				var $listItem = $('<li>', {
					class: listItemClass,
				});
				var $listItemButton = $('<button>', {
					text: headingText,
					type: 'button',
					class: itemButtonClass,
				});
				$listItem.append($listItemButton);
				$pageNavigationItems.append($listItem);

				$listItemButton.on('click', function () {
					if (headingText === $(this).text()) {
						var headingPosition =
							$heading.offset().top - pageNavigationHeight - self.offsetMobileMenu() - SCROLL_MARGIN;
						self.scrollToOnClick(headingPosition);
						self.collapseMenu();
					}
				});

				// Sets the page navigation height so it will maintain it once when position: fixed occurs
				pageNavigationHeight = $pageNavigationFixed.height();
				$pageNavigation.height(pageNavigationHeight);
			});
		},
		addKeyboardNavigation: function () {
			var self = this;
			var $pageNavigationItemButtons = $pageNavigationItems.find('button');
			var buttonsLength = $pageNavigationItemButtons.length;
			var lastButtonIndex = buttonsLength - 1;

			$pageNavigationItemButtons.on('keydown', function (e) {
				switch (e.keyCode) {
					case 27: // ESCAPE
						self.collapseMenu();
						listItemButtonIndex = 0;
						$pageNavigationButton.focus();
						break;
					case 38: // UP
					case 37: // LEFT
						e.preventDefault();
						e.stopImmediatePropagation();

						listItemButtonIndex--;

						if (listItemButtonIndex < 0) {
							$pageNavigationItemButtons.get(lastButtonIndex).focus();
							listItemButtonIndex = lastButtonIndex;
						} else {
							$pageNavigationItemButtons.get(listItemButtonIndex).focus();
						}

						break;

					case 40: // DOWN
					case 39: // RIGHT
						e.preventDefault();
						e.stopImmediatePropagation();

						listItemButtonIndex++;

						if (listItemButtonIndex > lastButtonIndex) {
							$pageNavigationItemButtons.get(0).focus();
							listItemButtonIndex = 0;
						} else {
							$pageNavigationItemButtons.get(listItemButtonIndex).focus();
						}

						break;
				}
			});
		},
		addScrollEvents: function () {
			var parentWidth = $pageNavigation.parent().width();
			var self = this;

			// Adds width to pageNavigation since it's not possible to get it responsive with css and postition: fixed
			$pageNavigationFixed.width(parentWidth);

			function addFixedClass() {
				var offsetTop = $pageNavigation.offset().top;
				if ($(window).scrollTop() > offsetTop - self.offsetMobileMenu()) {
					$pageNavigation.addClass(fixedClass);
				} else {
					$pageNavigation.removeClass(fixedClass);
				}
			}

			function initScrollSpy() {
				$h2headings.each(function (i, heading) {
					var $heading = $(heading);
					var scrollFromTop = Math.floor($(window).scrollTop());
					var headingOffset = Math.floor($heading.offset().top);
					var $listItems = $pageNavigationItems.find('li');
					if (scrollFromTop >= headingOffset - pageNavigationHeight - self.offsetMobileMenu() - SCROLL_MARGIN) {
						$listItems.removeClass(activeListItemClass);
						$listItems.eq(i).addClass(activeListItemClass);
					}
				});
			}
			addFixedClass();
			initScrollSpy();

			$(window).on('scroll', function () {
				addFixedClass();
				initScrollSpy();
			});
		},
		addBackToTopLink: function () {
			var self = this;
			$pageNavigationToTop.on('click', function () {
				self.scrollToOnClick(0);
			});
		},
		offsetMobileMenu: function () {
			var isMobile = window.innerWidth < MOBILE_BREAKPOINT;
			return (mobilemenuOffheight = isMobile ? MOBILE_MENU_HEIGHT : 0);
		},
		collapseMenu: function () {
			$pageNavigation.removeClass(expandedClass);
			$pageNavigationButton.attr('aria-expanded', false);
			$pageNavigationItems.attr('aria-hidden', true);
		},
		scrollToOnClick: function (position) {
			$('html, body').animate({ scrollTop: position }, SCROLL_SPEED);
		},
		initOutsideClick: function () {
			var self = this;
			document.addEventListener('click', function (event) {
				var isOutside = helper.outsideClick('.page-navigation', event);
				if (isOutside) self.collapseMenu();
			});
		},
	};
	createPagenavigation.init();
});
